export const BASE_URL = 'https://www.seacloud-software.hr/demo/taxi-radenovic';

export const LANGUAGES = [
  { code: 'hr', label: 'Hrvatski', flag: '🇭🇷', hreflang: 'hr-HR', locale: 'hr_HR' },
  { code: 'en', label: 'English', flag: '🇬🇧', hreflang: 'en', locale: 'en_US' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪', hreflang: 'de', locale: 'de_DE' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹', hreflang: 'it', locale: 'it_IT' },
];

export const DEFAULT_LANG = 'hr';
export const LANG_CODES = LANGUAGES.map((lang) => lang.code);

export function isValidLang(code) {
  return LANG_CODES.includes(code);
}

export function langPath(lang) {
  return lang === DEFAULT_LANG ? BASE_URL : `${BASE_URL}/${lang}`;
}

const SERVICES = {
  hr: [
    {
      id: 'airport',
      title: 'Prijevozi do zračnih luka',
      description: 'Pula, Zagreb, Venecija, Ljubljana i Trst — točno na vrijeme, svaki put.',
      icon: 'airplane',
    },
    {
      id: 'long-distance',
      title: 'Duge privatne vožnje',
      description: 'Udobni prekogranični prijevozi diljem Hrvatske i EU.',
      icon: 'road',
    },
    {
      id: 'door-to-door',
      title: 'Usluga od vrata do vrata',
      description: 'Preuzimanje i odvoz točno gdje trebate — hoteli, vile, marine.',
      icon: 'door',
    },
    {
      id: 'on-request',
      title: 'Samo na zahtjev',
      description: 'Osobna, diskretna usluga prilagođena vašem rasporedu.',
      icon: 'key',
    },
  ],
  en: [
    {
      id: 'airport',
      title: 'Airport Transfers',
      description: 'Pula, Zagreb, Venice, Ljubljana & Trieste airports — on time, every time.',
      icon: 'airplane',
    },
    {
      id: 'long-distance',
      title: 'Long-Distance Private Rides',
      description: 'Comfortable cross-border transfers across Croatia and the EU.',
      icon: 'road',
    },
    {
      id: 'door-to-door',
      title: 'Door-to-Door Service',
      description: 'Pickup and drop-off exactly where you need — hotels, villas, marinas.',
      icon: 'door',
    },
    {
      id: 'on-request',
      title: 'On Request Only',
      description: 'Personal, discreet service tailored to your schedule.',
      icon: 'key',
    },
  ],
  de: [
    {
      id: 'airport',
      title: 'Flughafentransfers',
      description: 'Pula, Zagreb, Venedig, Ljubljana & Triest — pünktlich, jedes Mal.',
      icon: 'airplane',
    },
    {
      id: 'long-distance',
      title: 'Langstrecken-Privatfahrten',
      description: 'Komfortable grenzüberschreitende Transfers in Kroatien und der EU.',
      icon: 'road',
    },
    {
      id: 'door-to-door',
      title: 'Tür-zu-Tür-Service',
      description: 'Abholung und Abgabe genau dort, wo Sie es brauchen — Hotels, Villen, Marinas.',
      icon: 'door',
    },
    {
      id: 'on-request',
      title: 'Nur auf Anfrage',
      description: 'Persönlicher, diskreter Service nach Ihrem Zeitplan.',
      icon: 'key',
    },
  ],
  it: [
    {
      id: 'airport',
      title: 'Transfer aeroportuali',
      description: 'Pula, Zagabria, Venezia, Lubiana e Trieste — puntuali, ogni volta.',
      icon: 'airplane',
    },
    {
      id: 'long-distance',
      title: 'Trasferimenti privati a lunga distanza',
      description: 'Trasferimenti transfrontalieri confortevoli in Croazia e nell\'UE.',
      icon: 'road',
    },
    {
      id: 'door-to-door',
      title: 'Servizio porta a porta',
      description: 'Prelievo e consegna esattamente dove serve — hotel, ville, marine.',
      icon: 'door',
    },
    {
      id: 'on-request',
      title: 'Solo su richiesta',
      description: 'Servizio personale e discreto su misura per il vostro programma.',
      icon: 'key',
    },
  ],
};

const DESTINATIONS = {
  hr: [
    {
      id: 'pula',
      name: 'Pula',
      country: 'Hrvatska',
      description: 'Lokalni prijevozi, zračna luka Pula, Arena i stari grad.',
      duration: 'Lokalno',
      landmark: 'arena',
    },
    {
      id: 'zagreb',
      name: 'Zagreb',
      country: 'Hrvatska',
      description: 'Glavni grad i prijevozi do zračne luke Zagreb.',
      duration: '~3h',
      landmark: 'cathedral',
    },
    {
      id: 'venice',
      name: 'Venecija',
      country: 'Italija',
      description: 'Zračna luka Marco Polo i centar Venecije.',
      duration: '~3h',
      landmark: 'basilica',
    },
    {
      id: 'ljubljana',
      name: 'Ljubljana',
      country: 'Slovenija',
      description: 'Zračna luka Ljubljana i gradski prijevozi.',
      duration: '~2h',
      landmark: 'castle',
    },
    {
      id: 'trieste',
      name: 'Trst',
      country: 'Italija',
      description: 'Zračna luka Trst i prijevozi do luke.',
      duration: '~1,5h',
      landmark: 'harbor',
    },
  ],
  en: [
    {
      id: 'pula',
      name: 'Pula',
      country: 'Croatia',
      description: 'Local transfers, Pula Airport, Arena & old town.',
      duration: 'Local',
      landmark: 'arena',
    },
    {
      id: 'zagreb',
      name: 'Zagreb',
      country: 'Croatia',
      description: 'Capital city & Zagreb Airport transfers.',
      duration: '~3h',
      landmark: 'cathedral',
    },
    {
      id: 'venice',
      name: 'Venice',
      country: 'Italy',
      description: 'Marco Polo Airport & Venice city centre.',
      duration: '~3h',
      landmark: 'basilica',
    },
    {
      id: 'ljubljana',
      name: 'Ljubljana',
      country: 'Slovenia',
      description: 'Ljubljana Airport & city transfers.',
      duration: '~2h',
      landmark: 'castle',
    },
    {
      id: 'trieste',
      name: 'Trieste',
      country: 'Italy',
      description: 'Trieste Airport & port city transfers.',
      duration: '~1.5h',
      landmark: 'harbor',
    },
  ],
  de: [
    {
      id: 'pula',
      name: 'Pula',
      country: 'Kroatien',
      description: 'Lokale Transfers, Flughafen Pula, Arena & Altstadt.',
      duration: 'Lokal',
      landmark: 'arena',
    },
    {
      id: 'zagreb',
      name: 'Zagreb',
      country: 'Kroatien',
      description: 'Hauptstadt & Transfers zum Flughafen Zagreb.',
      duration: '~3 Std.',
      landmark: 'cathedral',
    },
    {
      id: 'venice',
      name: 'Venedig',
      country: 'Italien',
      description: 'Flughafen Marco Polo & Venedig Stadtzentrum.',
      duration: '~3 Std.',
      landmark: 'basilica',
    },
    {
      id: 'ljubljana',
      name: 'Ljubljana',
      country: 'Slowenien',
      description: 'Flughafen Ljubljana & Stadttransfers.',
      duration: '~2 Std.',
      landmark: 'castle',
    },
    {
      id: 'trieste',
      name: 'Triest',
      country: 'Italien',
      description: 'Flughafen Triest & Hafenstadt-Transfers.',
      duration: '~1,5 Std.',
      landmark: 'harbor',
    },
  ],
  it: [
    {
      id: 'pula',
      name: 'Pula',
      country: 'Croazia',
      description: 'Trasferimenti locali, aeroporto di Pula, Arena e centro storico.',
      duration: 'Locale',
      landmark: 'arena',
    },
    {
      id: 'zagreb',
      name: 'Zagabria',
      country: 'Croazia',
      description: 'Capitale e trasferimenti per l\'aeroporto di Zagabria.',
      duration: '~3h',
      landmark: 'cathedral',
    },
    {
      id: 'venice',
      name: 'Venezia',
      country: 'Italia',
      description: 'Aeroporto Marco Polo e centro di Venezia.',
      duration: '~3h',
      landmark: 'basilica',
    },
    {
      id: 'ljubljana',
      name: 'Lubiana',
      country: 'Slovenia',
      description: 'Aeroporto di Lubiana e trasferimenti in città.',
      duration: '~2h',
      landmark: 'castle',
    },
    {
      id: 'trieste',
      name: 'Trieste',
      country: 'Italia',
      description: 'Aeroporto di Trieste e trasferimenti per il porto.',
      duration: '~1,5h',
      landmark: 'harbor',
    },
  ],
};

const COPY = {
  hr: {
    brandSubtitle: 'PRIJEVOZI ISTRE',
    tagline: 'PRIVATNI PRIJEVOZI HRVATSKA I EU',
    serviceTitle: 'PRIVATNA VOZAČKA USLUGA',
    heroLead: 'Privatni vozač iz Poreča — diskretni, profesionalni prijevozi diljem Hrvatske i EU.',
    scroll: 'Pomakni',
    servicesTitle: 'Kako vam pomažemo',
    destinationsEyebrow: 'Destinacije',
    destinationsTitle: 'Istra i šire',
    destinationsLead: 'Privatni prijevozi do hrvatske obale, glavnog grada i susjednih EU gradova.',
    aboutTitle: 'Vaš privatni vozač u Istri',
    aboutLead:
      'Sa sjedištem u Poreču nudimo diskretne prijevoze od vrata do vrata udobnim {vehicle}. Samo na zahtjev — prilagođeno vašem rasporedu.',
    values: ['Diskretno', 'Profesionalno', 'Privatno'],
    contactTitle: 'Rezervirajte prijevoz',
    contactLead: 'Nazovite ili pošaljite poruku da dogovorite privatnu vožnju.',
    carAlt: 'Vozilo za privatne prijevoze',
    footerNote: 'Demo POC — SeaCloud Software.',
    gateTitle: 'Demo privatnih prijevoza',
    gateSub: 'Povjerljiva demonstracija izrađena od strane SeaCloud Softwarea. Unesite pristupni kod za nastavak.',
    gatePlaceholder: 'Pristupni kod',
    gateEnter: 'Ulaz',
    gateError: 'Pogrešan pristupni kod',
    gateLoading: 'Učitavanje…',
    gateFoot: 'Samo demo — POC landing stranica',
    langLabel: 'Odaberite jezik',
    seo: {
      title: 'Taxi Radenović | Privatni prijevozi Istria — Pula, Zagreb, Venecija, Ljubljana, Trst',
      description:
        'Privatni taxi prijevozi iz Poreča, Istra. Prijevozi do zračnih luka, duge vožnje, usluga od vrata do vrata. Pula, Zagreb, Venecija, Ljubljana, Trst. Nazovite +385 97 606 8055',
      keywords:
        'taxi Istra, prijevoz Pula, taxi Poreč, prijevoz Pula Zagreb, taxi Pula Venecija, taxi Ljubljana, prijevoz Trst, privatni vozač Istra, prijevoz do zračne luke Hrvatska',
    },
    schemaServiceTypes: ['Prijevozi do zračnih luka', 'Duge privatne vožnje', 'Usluga od vrata do vrata'],
  },
  en: {
    brandSubtitle: 'ISTRIA TRANSFERS',
    tagline: 'CROATIA & EU PRIVATE TRANSFERS',
    serviceTitle: 'PRIVATE DRIVER SERVICE',
    heroLead: 'Private driver service from Poreč — discreet, professional transfers across Croatia and the EU.',
    scroll: 'Scroll',
    servicesTitle: 'How we serve you',
    destinationsEyebrow: 'Destinations',
    destinationsTitle: 'Istria & beyond',
    destinationsLead: 'Private transfers to Croatia\'s coast, capital, and neighbouring EU cities.',
    aboutTitle: 'Your private driver in Istria',
    aboutLead:
      'Based in Poreč, we offer discreet door-to-door transfers with a comfortable {vehicle}. On request only — tailored to your schedule.',
    values: ['Discreet', 'Professional', 'Private'],
    contactTitle: 'Book your transfer',
    contactLead: 'Call or message us to arrange your private ride.',
    carAlt: 'Private transfer service vehicle',
    footerNote: 'Demo POC by SeaCloud Software.',
    gateTitle: 'Private Transfer Demo',
    gateSub: 'Confidential demonstration built by SeaCloud Software. Enter access code to continue.',
    gatePlaceholder: 'Access code',
    gateEnter: 'Enter',
    gateError: 'Incorrect access code',
    gateLoading: 'Loading…',
    gateFoot: 'Demo only — POC landing page',
    langLabel: 'Select language',
    seo: {
      title: 'Taxi Radenovic | Private Transfers Istria — Pula, Zagreb, Venice, Ljubljana, Trieste',
      description:
        'Croatia & EU private taxi transfers from Poreč, Istria. Airport transfers, long-distance rides, door-to-door service. Pula, Zagreb, Venice, Ljubljana, Trieste. Call +385 97 606 8055',
      keywords:
        'taxi Istria, transfer Pula, taxi Poreč, Pula to Zagreb transfer, Pula to Venice taxi, taxi Ljubljana, Trieste transfer, private driver Istria, airport transfer Croatia',
    },
    schemaServiceTypes: ['Airport Transfers', 'Long-Distance Private Rides', 'Door-to-Door Service'],
  },
  de: {
    brandSubtitle: 'ISTRIEN TRANSFERS',
    tagline: 'PRIVATTRANSFERS KROATIEN & EU',
    serviceTitle: 'PRIVATER FAHRERSERVICE',
    heroLead: 'Privater Fahrerservice aus Poreč — diskrete, professionelle Transfers in Kroatien und der EU.',
    scroll: 'Scrollen',
    servicesTitle: 'So betreuen wir Sie',
    destinationsEyebrow: 'Reiseziele',
    destinationsTitle: 'Istrien & darüber hinaus',
    destinationsLead: 'Private Transfers an die kroatische Küste, in die Hauptstadt und in benachbarte EU-Städte.',
    aboutTitle: 'Ihr privater Fahrer in Istrien',
    aboutLead:
      'Mit Sitz in Poreč bieten wir diskrete Tür-zu-Tür-Transfers mit einem komfortablen {vehicle}. Nur auf Anfrage — nach Ihrem Zeitplan.',
    values: ['Diskret', 'Professionell', 'Privat'],
    contactTitle: 'Transfer buchen',
    contactLead: 'Rufen Sie uns an oder schreiben Sie uns, um Ihre private Fahrt zu vereinbaren.',
    carAlt: 'Fahrzeug für Privattransfers',
    footerNote: 'Demo POC — SeaCloud Software.',
    gateTitle: 'Demo Privattransfers',
    gateSub: 'Vertrauliche Demonstration von SeaCloud Software. Zugangscode eingeben, um fortzufahren.',
    gatePlaceholder: 'Zugangscode',
    gateEnter: 'Eintreten',
    gateError: 'Falscher Zugangscode',
    gateLoading: 'Laden…',
    gateFoot: 'Nur Demo — POC-Landingpage',
    langLabel: 'Sprache wählen',
    seo: {
      title: 'Taxi Radenović | Private Transfers Istrien — Pula, Zagreb, Venedig, Ljubljana, Triest',
      description:
        'Private Taxi-Transfers aus Poreč, Istrien. Flughafentransfers, Langstreckenfahrten, Tür-zu-Tür-Service. Pula, Zagreb, Venedig, Ljubljana, Triest. +385 97 606 8055',
      keywords:
        'Taxi Istrien, Transfer Pula, Taxi Poreč, Transfer Pula Zagreb, Taxi Pula Venedig, Taxi Ljubljana, Transfer Triest, privater Fahrer Istrien, Flughafentransfer Kroatien',
    },
    schemaServiceTypes: ['Flughafentransfers', 'Langstrecken-Privatfahrten', 'Tür-zu-Tür-Service'],
  },
  it: {
    brandSubtitle: 'TRASFERIMENTI ISTRIA',
    tagline: 'TRASFERIMENTI PRIVATI CROAZIA E UE',
    serviceTitle: 'SERVIZIO AUTISTA PRIVATO',
    heroLead: 'Servizio autista privato da Parenzo — trasferimenti discreti e professionali in Croazia e nell\'UE.',
    scroll: 'Scorri',
    servicesTitle: 'Come vi serviamo',
    destinationsEyebrow: 'Destinazioni',
    destinationsTitle: 'Istria e oltre',
    destinationsLead: 'Trasferimenti privati verso la costa croata, la capitale e le città UE vicine.',
    aboutTitle: 'Il vostro autista privato in Istria',
    aboutLead:
      'Con sede a Parenzo, offriamo trasferimenti discreti porta a porta con una comoda {vehicle}. Solo su richiesta — su misura per il vostro programma.',
    values: ['Discreto', 'Professionale', 'Privato'],
    contactTitle: 'Prenotate il trasferimento',
    contactLead: 'Chiamateci o scriveteci per organizzare il vostro viaggio privato.',
    carAlt: 'Veicolo per trasferimenti privati',
    footerNote: 'Demo POC — SeaCloud Software.',
    gateTitle: 'Demo trasferimenti privati',
    gateSub: 'Dimostrazione riservata realizzata da SeaCloud Software. Inserite il codice di accesso per continuare.',
    gatePlaceholder: 'Codice di accesso',
    gateEnter: 'Entra',
    gateError: 'Codice di accesso errato',
    gateLoading: 'Caricamento…',
    gateFoot: 'Solo demo — landing page POC',
    langLabel: 'Seleziona lingua',
    seo: {
      title: 'Taxi Radenović | Trasferimenti privati Istria — Pula, Zagabria, Venezia, Lubiana, Trieste',
      description:
        'Taxi e trasferimenti privati da Parenzo, Istria. Transfer aeroportuali, lunghe distanze, servizio porta a porta. Pula, Zagabria, Venezia, Lubiana, Trieste. +385 97 606 8055',
      keywords:
        'taxi Istria, transfer Pula, taxi Poreč, transfer Pula Zagabria, taxi Pula Venezia, taxi Lubiana, transfer Trieste, autista privato Istria, transfer aeroporto Croazia',
    },
    schemaServiceTypes: ['Transfer aeroportuali', 'Trasferimenti privati a lunga distanza', 'Servizio porta a porta'],
  },
};

export function getTaxiCopy(lang) {
  const code = isValidLang(lang) ? lang : DEFAULT_LANG;
  const copy = COPY[code];

  return {
    lang: code,
    ...copy,
    services: SERVICES[code],
    destinations: DESTINATIONS[code],
    seo: {
      ...copy.seo,
      canonical: langPath(code),
      ogImage: 'https://www.seacloud-software.hr/images/taxi-radenovic-logo.svg',
    },
  };
}
